import yup from '../../../config/yup';

export const localFileImporterValidationSchema = yup.object().shape({
  '@id': yup.string().required('Format ID is required'),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('localFileImporter'),
  format: yup.string().required('Format is required'),
  properties: yup.object().shape({
    fileName: yup.string().required('File Name is required'),
  }),
});
